import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import WindowStickerSize from 'src/app/model/product/windowsticker/windowsticker-size';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class WindowStickerSizeSingleSizeControllerRequestService {
  private static BASE_URL = '/window_sticker_sizes/singlesize';
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as WindowStickerSize;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get(
      WindowStickerSizeSingleSizeControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public getSingleSizeForMaterial(
    materialOrdinal: number,
    height: number,
    width: number
  ): Promise<WindowStickerSize> {
    return this.get(
      `/${materialOrdinal}/${height}/${width}`,
      this.deserialize
    ).toPromise();
  }
}
